'use client';

import { useRef } from 'react';
import HeroSection from './HeroSection';
import ComparisonSection from './ComparisonSection';
import TimelineSection from './TimelineSection';
import BenefitsSection from './BenefitsSection';
import CaseStudiesSection from './CaseStudiesSection';
import ProcessSection from './ProcessSection';
import FAQSection from './FAQSection';
import CTASection from './CTASection';

const FinancialPlanInteractive = () => {
  const timelineRef = useRef<HTMLDivElement>(null);

  const scrollToTimeline = () => {
    timelineRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <HeroSection onScrollToTimeline={scrollToTimeline} />
      <ComparisonSection />
      <div ref={timelineRef}>
        <TimelineSection />
      </div>
      <BenefitsSection />
      <CaseStudiesSection />
      <ProcessSection />
      <FAQSection />
      <CTASection />
    </>
  );
};

export default FinancialPlanInteractive;